import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, FooterService } from '../../../core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  maintenanceMessage: any;

  constructor(
    private footerService: FooterService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.getMaintenance();
  }

  getMaintenance() {
    this.footerService.getMaintenanceMessage().subscribe(
      (data) => {
        this.maintenanceMessage = data;
        if (data && !data.underMaintenance) {
          this.authService.clearAll();
          window.location.href = '/';
        }
      },
      () => {}
    );
  }
}
